import React from 'react';
import { Row, Col, Glyphicon, Modal } from 'react-bootstrap';
import {
  Button,
} from '../../../form/FormControls.jsx';
import { UrlWrappedRow, getFontColorFromBackground,
  addFromTab } from '../../../../util/util.jsx';
import { formatRange, BOLD_FONT, formatNumber } from './BaseElement.jsx';
import { tryToDeleteDeal } from '../store/deal.store';
import { connect } from 'react-redux';
import { getDealListWrapper } from '../store/DealsWrapper';
import { loadDealCopy } from '@/store/allaround.store';
import { push } from 'react-router-redux';
import PurchaseSaleElement from './PurchaseSaleElement.jsx';
import { PortElement } from './PortElement.jsx';
import { transportStatus } from '../../../dict/Enums.js';
import { List } from 'immutable';
import vessel from '@/../style/vessel.png';
import container from '@/../style/container.png';
import railcar from '@/../style/railcar.png';
import truck from '@/../style/truck.png';
import { validateRoleConfig } from '../../../auth/RoleConfigFilter.jsx';
import duplicate from '../../../../../style/duplicatelight.png';
import trash from '../../../../../style/trashlight.png';
import loadport from '@/../style/loadportblue.png';
import unloadport from '@/../style/unloadportblue.png';

export function formTransportName(data, style) {
  let transportName = '';
  if (data && data.get('transportType') == 'CONTAINER'
    && data.get('transportNameVoyage')) {
    transportName =
        data.get('transportNameVoyage').map((elem, idx) =>
          (typeof elem.get === 'function' &&
            (elem.get('vesselName') || elem.get('voyageNumber')) ?
            <span className="tag-alike" key={idx}>
              <span
                className="text-primary"
                style={{ display: 'inline', wordBreak: 'break-all', whiteSpace: 'normal',
                  fontWeight: 'bold', lineHeight: '25px', ...style }}
              >
                {`${elem.get('vesselName') || ''} `}{elem.get('voyageNumber') || ' '}
              </span>
            </span>
            : ''));
  } else if (data) {
    transportName = data.get('vesselName')
      ?
      <span
        className="text-primary"
        style={{ ...BOLD_FONT, display: 'inline',
          whiteSpace: 'normal', lineHeight: '25px', ...style }}
      >
        {data.get('vesselName')}
      </span>
      : '';
  }
  return transportName;
}

export function getTotalBL(transport = new Map()) {
  const links = transport.get('links', new List()).filter((l) => !l.get('hidden'));
  if (links && links.size > 0) {
    return links.reduce((sum, l) => sum + l.get('billLandingQuantity'), 0);
  }
  return 0;
}

class TransportElementClass extends React.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.yesButton = this.yesButton.bind(this);
    this.dealCopy = this.dealCopy.bind(this);
    this.state = { showModal: false };
  }
  componentWillMount() {
    getDealListWrapper('sale');
    getDealListWrapper('purchase');
  }
  componentWillReceiveProps(props) {
    getDealListWrapper('sale');
    getDealListWrapper('purchase');

    if (props.dealCopy && props.dealCopy.get('dealType') == 'transport') {
      this.props.navigateToDealCopyCreation();
    }
  }

  openModal(e) {
    e.stopPropagation();
    this.setState({ showModal: true });
  }
  closeModal() {
    this.setState({ showModal: false });
  }
  yesButton() {
    this.props.tryToDeleteDeal(this.props.data.get('id'));
    this.setState({ showModal: false });
  }

  groupBy(map, attr, item) {
    const key = item.get(attr);
    if (!map.has(key)) {
      map.set(key, []);
    }
    map.get(key).push(item);
  }
  group(array, groupedByPurhcase, groupedBySale) {
    const result = new Map();
    array.forEach(link => this.groupBy(result, 'purchaseId', link));
    let bufferedItems = [];
    result.forEach((item, key) => {
      if (key !== null && key !== undefined &&
        (item.length > 1 || item.saleId === undefined || item.saleId === null)) {
        groupedByPurhcase.set(key, item);
      } else {
        bufferedItems = bufferedItems.concat(item);
      }
    });
    bufferedItems.forEach(item => this.groupBy(groupedBySale, 'saleId', item));
  }

  filterLinks(deal, linkPropertyName, links) {
    const linkIds = links.map(link => link.get('id'));
    const products = deal.get('products').map(prod => {
      const linkCollection = prod.get(linkPropertyName)
        .filter(link => linkIds.indexOf(link.get('id')) > -1)
        .map(link => link.delete('transport').set('transportList', true));
      if (linkCollection.size > 0) {
        return prod.set(linkPropertyName, linkCollection);
      }
      return undefined;
    }).filter(p => p);
    return products;
  }
  createPurchaseSaleElement(deal, links, dealType) {
    if (deal) {
      const products = this.filterLinks(deal, `${dealType}Link`, links);
      if (products.size > 0) {
        return (<PurchaseSaleElement
          transport={this.props.data}
          allowUrl={validateRoleConfig(['myDeals#1', 'allDeals#1'], deal)}
          dealType={dealType} disabled={this.props.disabled} originalData={deal}
          data={deal.set('products', products)} noControlls noStatus dealId={deal.get('id')}
        />);
      }
    }
    return '';
  }
  createPurchaseElement(id, links) {
    const deal = this.props.purchaseList.find(pur => pur.get('id') == id);
    return this.createPurchaseSaleElement(deal, links, 'purchase');
  }

  createSaleElement(id, links) {
    const deal = this.props.saleList.find(sl => sl.get('id') == id);
    return this.createPurchaseSaleElement(deal, links, 'sale');
  }

  dealCopy(e) {
    e.stopPropagation();
    this.props.loadDealCopy(this.props.data.get('id'));
  }

  render() {
    const linkElems = [];
    const links = this.props.data.get('links');
    let loadPortNumber = 1;
    let dischargePortNumber = 1;
    if (links && links.size > 0) {
      const groupedByPurhcase = new Map();
      const groupedBySale = new Map();
      this.group(links, groupedByPurhcase, groupedBySale);

      const panelStyle = { margin: '0 0 10px' };
      groupedByPurhcase.forEach((purchaseLinks, pid) => {
        linkElems.push(
          <Row key={`p_${pid}`} style={panelStyle}>
            <Col sm={12} style={{ minHeight: '100%' }}>
              {this.createPurchaseElement(pid, purchaseLinks)}
            </Col>
          </Row>
        );
      });
      groupedBySale.forEach((saleLinks, pid) => {
        linkElems.push(
          <Row key={`s_${pid}`} style={panelStyle}>
            <Col sm={12} style={{ minHeight: '100%' }}>
              {this.createSaleElement(pid, saleLinks)}
            </Col>
          </Row>
        );
      });
    }
    let icon = '';
    if (this.props.data.get('transportType')) {
      switch (this.props.data.get('transportType').toLowerCase()) {
        case 'bulk':
          icon = <img alt="Bulk Vessel" src={vessel} style={{ height: '2em' }} />;
          break;
        case 'container':
          icon = <img alt="Contrainer ship" src={container} style={{ height: '2em' }} />;
          break;
        case 'truck':
          icon = <img alt="Truck" src={truck} style={{ height: '2em' }} />;
          break;
        case 'railcar':
          icon = <img alt="Railcar" src={railcar} style={{ height: '2em' }} />;
          break;
        default:
          break;
      }
    }
    let laycan = '';
    if (this.props.data.get('transportType') == 'BULK' && this.props.data.get('vesselLoadingPorts')
        && this.props.data.get('vesselLoadingPorts').size > 0) {
      laycan = formatRange(this.props.data.getIn(['vesselLoadingPorts', 0, 'laycanStart']),
        this.props.data.getIn(['vesselLoadingPorts', 0, 'laycanEnd']));
    }
    const transportName = formTransportName(this.props.data);
    const totalBL = getTotalBL(this.props.data);
    return (
      <UrlWrappedRow
        url={!this.props.editForm ?
          `/deals/transport/${this.props.data.get('id')}${addFromTab()}` : undefined}
        className="transport"
        id={`tr_deal_${this.props.dealIdx}`}
      >
        <Modal bsSize="small" show={this.state.showModal} onHide={this.closeModal} >
          <Modal.Body bsClass="modal-link-body">
            Are you sure you want to delete transport?
          </Modal.Body>
          <Modal.Footer bsClass="modal-link-footer">
            <div>
              <Button bsStyle="danger" onClick={this.yesButton}>Yes</Button>
              <Button onClick={this.closeModal}>No</Button>
            </div>
          </Modal.Footer>
        </Modal>
        <Col
          xs={12}
          className={`purchase-list ${
            this.props.editForm && linkElems.length ? 'purchase-list-links' : ''
          }`}
          style={!this.props.editForm ? {} : { background: 'white' }}
        >
          {!this.props.editForm ? <div>
            <Row>
              <Col md={12} className={'transport-element-name-container'}>
                <div className={'transport-element-name'}>
                  {icon}&nbsp;&nbsp;{transportName}
                </div>
              </Col>
            </Row>
            <Row style={{ paddingTop: 5 }}>
              <Col md={8}>
                <Row>
                  <Col xs={12}>
                    <img
                      src={loadport}
                      alt={'Loading ports'} className={'small-transport-port-icon'}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    {this.props.data.get('transportType') == 'CONTAINER' ?
                      <Row>
                        <Col lg={2}>
                          <span
                            className="text-primary" style={{ ...BOLD_FONT, textAlign: 'left' }}
                          >
                    Cut off date
                          </span>
                        </Col>
                        <Col lg={10} style={{ padding: 0 }}>
                          {this.props.data.get('cutOffDate')}
                        </Col>
                      </Row> : ''
                    }
                    {this.props.data.get('transportType') == 'BULK' ?
                      <Row>
                        <Col lg={2}>
                          <span
                            className="text-primary"
                            style={{ ...BOLD_FONT, textAlign: 'left' }}
                          >
                    Laycan
                          </span>
                        </Col>
                        <Col lg={10} style={{ padding: 0 }}>
                          <span style={{ whiteSpace: 'normal' }}>
                            {laycan}
                          </span>
                        </Col>
                      </Row> : ''
                    }
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Row>
                      <Col lg={2} style={{ textAlign: 'left' }}>
                        <span className="text-primary" style={{ ...BOLD_FONT, textAlign: 'left' }}>
                    Loading ports
                        </span>
                      </Col>
                      <Col
                        lg={10} style={{ textAlign: 'left', padding: 0 }}
                        className={'transport-list-ports'}
                      >
                        <span
                          style={{ whiteSpace: 'normal', wordBreak: 'break-all', display: 'block' }}
                        >
                          {
                            this.props.data.get('transportType') == 'CONTAINER'
                        && this.props.data.get('loadingPort') !== undefined
                              ?
                              <div>
                                <PortElement
                                  portId={this.props.data.get('loadingPort')}
                                  status={this.props.data.get('loadingPortStatus')}
                                  portType="vesselLoadingPorts"
                                  sailingDate={this.props.data.get('loadingSailingDate')}
                                  blDate={this.props.data.get('billLandingDate')}
                                  container
                                  noBorder
                                />
                              </div>
                              : ''
                          }
                          {
                            (this.props.data.get('transportType') == 'RAILCAR' ||
                          this.props.data.get('transportType') == 'TRUCK')
                        && this.props.data.get('loadingPort') !== undefined
                              ?
                              <div>
                                <PortElement
                                  portId={this.props.data.get('loadingPort')}
                                  status={this.props.data.get('loadingPortStatus')}
                                  portType="railcarLoadingPorts"
                                  sailingDate={this.props.data.get('loadingSailingDate')}
                                  blDate={this.props.data.get('billLandingDate')}
                                  container
                                  noBorder
                                />
                              </div>
                              : ''
                          }
                          {
                            this.props.data.get('transportType') == 'BULK'
                        && this.props.data.get('vesselLoadingPorts')
                              ? this.props.data.get('vesselLoadingPorts').map((port) =>
                                <PortElement
                                  prefix={<div style={{ display: 'inline' }}>
                                    {`${loadPortNumber++}. `}
                                  </div>}
                                  port={port}
                                  key={port.get('id')}
                                  portType="vesselLoadingPorts"
                                  style={{ display: 'inline-block', wordBreak: 'break-all',
                                    width: '100%' }}
                                  noBorder
                                />)
                              : ''
                          }
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col md={4}>
                <Row>
                  <Col xs={12}>
                    <img
                      src={unloadport}
                      alt={'Discharge ports'} className={'small-transport-port-icon'}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{ textAlign: 'left' }}>
                    {this.props.data.get('transportStatus') ?
                      <span className="text-primary" style={BOLD_FONT}>
                        {transportStatus.get(this.props.data.get('transportStatus'))}
                      </span>
                      : ''
                    }
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Row>
                      <Col md={3} style={{ textAlign: 'left' }}>
                        <span className="text-primary" style={{ ...BOLD_FONT, textAlign: 'left' }}>
                    Discharge ports
                        </span>
                      </Col>
                      <Col
                        md={9} style={{ textAlign: 'left' }}
                        className={'transport-list-ports'}
                      >
                        <span
                          style={{ whiteSpace: 'normal', wordBreak: 'break-all', display: 'block' }}
                        >
                          {
                            (this.props.data.get('transportType') == 'CONTAINER' ||
                          this.props.data.get('transportType') == 'RAILCAR' ||
                          this.props.data.get('transportType') == 'TRUCK')
                        && this.props.data.get('loadingPort') !== undefined
                              ?
                              <div>
                                <PortElement
                                  portId={this.props.data.get('dischargePort')}
                                  status={this.props.data.get('dischargePortStatus')}
                                  portType="vesselDischargePorts"
                                  eta={this.props.data.get('etaDischarge')}
                                  sailingDate={this.props.data.get('dischargeSailingDate')}
                                  container
                                  noBorder
                                />
                              </div>
                              : ''
                          }
                          {
                            this.props.data.get('transportType') == 'BULK'
                        && this.props.data.get('vesselDischargePorts')
                              ? this.props.data.get('vesselDischargePorts').map((port) =>
                                <PortElement
                                  prefix={<div style={{ display: 'inline' }}>
                                    {`${dischargePortNumber++}. `}
                                  </div>}
                                  port={port}
                                  key={port.get('id')}
                                  portType="vesselDischargePorts"
                                  style={{ display: 'inline-block', wordBreak: 'break-all',
                                    width: '100%' }}
                                  noBorder
                                />)
                              : ''
                          }
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>


            {totalBL ? <Row>
              <Col xs={8}>
                <Row>
                  <Col md={2} >
                    <span className="text-primary" style={{ ...BOLD_FONT, textAlign: 'left' }}>
                    Total BL
                    </span>
                  </Col>
                  <Col md={10} style={{ padding: 0 }}>
                    {formatNumber(totalBL, '0,0.[000]')}
                  </Col>
                </Row>
              </Col>
            </Row>
              : undefined}
            <Row style={{ padding: 5, margin: '5px 30px' }}>
              {
                this.props.data.get('calendarEvents')
                  ? this.props.data.get('calendarEvents').map((evt, idx) =>
                    <Col
                      xs={12} key={idx} style={{ border: '2px inset lightgray',
                        background: evt.get('color'), margin: '5px 0px 0px 0px',
                        padding: '0px 20px',
                        color: getFontColorFromBackground(evt.get('color')), textAlign: 'left' }}
                    >
                      <Row>
                        {
                          evt.get('startDate') == evt.get('endDate')
                            ? evt.get('startDate')
                            : <div>{evt.get('startDate')} - {evt.get('endDate')}</div>
                        }
                      </Row>
                      <Row style={{ wordBreak: 'break-all' }}>
                        {evt.get('fullDescription')}
                      </Row>
                    </Col>)
                  : ''
              }
            </Row>
          </div>
            : ''
          }
          {linkElems}
        </Col>
        {!this.props.editForm && <div style={{ float: 'left' }} className={'deal-list-controls'} >
          {validateRoleConfig(['myTransports#2', 'allTransports#2'],
            this.props.data) ?
            <Button
              bsStyle="link" onClick={this.dealCopy}
              style={{ padding: 0, paddingRight: '5px',
                lineHeight: 1, fontSize: '13px' }}
            >
              <img src={duplicate} alt={'Duplicate'} title={'Duplicate'} />
            </Button>
            : ''
          }
          {!(this.props.lock && this.props.lock.get('owner'))
          && validateRoleConfig(['myTransports#3', 'allTransports#3'],
            this.props.data) ?
            <Button
              bsStyle="link" onClick={this.openModal}
              style={{ padding: 0, lineHeight: 1, fontSize: '13px' }}
            >
              <img
                className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'}
              />
            </Button>
            : ''
          }
          {
            this.props.lock && this.props.lock.get('owner')
              ? <Button
                bsStyle="link"
                style={{ padding: 0, paddingLeft: '5px',
                  lineHeight: 1, fontSize: '12px' }}
              >
                <Glyphicon
                  glyph="lock"
                  title={`Locked by ${this.props.lock.get('owner')}` +
                  ` at ${new Date(this.props.lock.get('timeOfLocking'))}`}
                />
              </Button>
              : ''
          }
        </div>
        }
      </UrlWrappedRow>
    );
  }
}
TransportElementClass.propTypes = {
  data: React.PropTypes.object.isRequired,
  lock: React.PropTypes.object,
  tryToDeleteDeal: React.PropTypes.func,
  purchaseList: React.PropTypes.object,
  saleList: React.PropTypes.object,
  getPlaceName: React.PropTypes.func,
  editForm: React.PropTypes.bool,
  dealIdx: React.PropTypes.number,
  disabled: React.PropTypes.bool,
  navigateToDealCopyCreation: React.PropTypes.func,
  loadDealCopy: React.PropTypes.func,
  dealCopy: React.PropTypes.object,
};

export default connect((state) => ({
  purchaseList: state.getIn(['data', 'deals', 'list', 'purchase'], new List()),
  saleList: state.getIn(['data', 'deals', 'list', 'sale'], new List()),
  dealCopy: state.getIn(['allaround', 'dealCopy']),
}), (dispatch) => ({
  tryToDeleteDeal(id) {
    tryToDeleteDeal(dispatch, 'transport', id);
  },
  navigateToDealCopyCreation() {
    dispatch(push('/deals/transport/new'));
  },
  loadDealCopy(sourceId) {
    loadDealCopy(dispatch, 'transport', sourceId);
  },
}))(TransportElementClass);
